import { Controller } from "@hotwired/stimulus"

// Rewrites a server-rendered <time datetime="..."> tag to the visitor's
// local timezone + locale on connect. The server-rendered text remains as
// fallback if JS is disabled or this controller hasn't connected yet.
//
// Format keys mirror ApplicationHelper::LOCAL_TIME_FALLBACKS.
const FORMATS = {
  datetime:      { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true },
  datetime_full: { month: "long",  day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true },
  date_short:    { month: "short", day: "numeric" },
  day_month:     { day: "numeric", month: "short" },
  day_month_dot: { day: "numeric", month: "short" },
  datetime_log:  { month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }
}

export default class extends Controller {
  static values = { format: { type: String, default: "datetime" } }

  connect() {
    const iso = this.element.getAttribute("datetime")
    if (!iso) return
    const date = new Date(iso)
    if (isNaN(date.getTime())) return

    const opts = FORMATS[this.formatValue] || FORMATS.datetime
    let text = date.toLocaleString(undefined, opts)

    // Format-specific tweaks. Intl can't produce "1·Jun" directly, so we
    // post-process the day_month output. Same idea for the log format
    // which Intl renders with a comma we want to drop.
    if (this.formatValue === "day_month_dot") {
      // "Jun 1" or "1 Jun" → "1·Jun"
      text = text.replace(/^(\w+)\s+(\d+)$/, "$2·$1").replace(/^(\d+)\s+(\w+)$/, "$1·$2")
    } else if (this.formatValue === "datetime_log") {
      // "06/01, 14:42:50" → "06-01 14:42:50"
      text = text.replace(/[\/,]/g, "-").replace(/-\s+/, " ").replace(/-(\d{2}:)/, " $1")
    }

    this.element.textContent = text
  }
}
